import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Manage } from 'src/app/manage/manage';
import { ManageService } from 'src/app/manage/manage.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-accessmanagement',
  templateUrl: './accessmanagement.component.html',
  styleUrls: ['./accessmanagement.component.css']
})
export class AccessmanagementComponent implements OnInit {
  p: number = 1;
  Manage: Manage[] = [];
  hideWhenNoStudent: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;
  isReorderMode: boolean = false; // Add this line

  constructor(
    public toastr: ToastrService, 
    public manageService: ManageService
  ) {}

  ngOnInit(): void {
    this.dataState();
    this.loadManagementTeam();
  }

  loadManagementTeam() {
    let s = this.manageService.GetStudentsList();
    s.snapshotChanges().subscribe(data => {
      this.Manage = [];
      data.forEach(item => {
        let a = item.payload.toJSON();
        a['$key'] = item.key;
        if (!a['position']) {
          a['position'] = 999;
        }
        this.Manage.push(a as Manage);
      });
      
      // Sort by position
      this.Manage.sort((a, b) => (a.position || 999) - (b.position || 999));
    });
  }

  dataState() {
    this.manageService.GetStudentsList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if (data.length <= 0) {
        this.hideWhenNoStudent = false;
        this.noData = true;
      } else {
        this.hideWhenNoStudent = true;
        this.noData = false;
      }
    });
  }

  // Add these new methods
  toggleReorderMode() {
    this.isReorderMode = !this.isReorderMode;
  }

  moveUp(index: number) {
    if (index > 0) {
      [this.Manage[index], this.Manage[index - 1]] = [this.Manage[index - 1], this.Manage[index]];
      this.updatePositions();
    }
  }

  moveDown(index: number) {
    if (index < this.Manage.length - 1) {
      [this.Manage[index], this.Manage[index + 1]] = [this.Manage[index + 1], this.Manage[index]];
      this.updatePositions();
    }
  }

  updatePositions() {
    this.Manage.forEach((manage, index) => {
      const updatedData = {
        name: manage.name,
        title: manage.title,
        image: manage.image,
        abouta: manage.abouta,
        aboutb: manage.aboutb,
        aboutc: manage.aboutc,
        aboutd: manage.aboutd,
        position: index + 1
      };
      this.manageService.UpdateStudent(manage.$key, updatedData);
    });
  }

  deletee(manage) {
    if (confirm('Are you sure you want to delete this management team member?')) {
      this.manageService.DeleteStudent(manage.$key);
    }
  }
}